import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import { Field, useFormikContext } from 'formik'

import { InputGroup, MultiInputConveter } from '../../../../../components'
import { RenderIf, isEmpty, toFractionDigits } from '../../../../../utils/fns'
import { MEASURE_UNITS } from '../../../../../utils/constants'
import { useLazyEffect } from '../../../../../utils/hooks'

const WallLengthInput = (props) => {
  const { setFieldValue, errors, values } = useFormikContext()
  const { value: original, onChange } = props

  const toDecimalValue = (value) => {
    return isEmpty(value) || isNaN(value) ? value : toFractionDigits(value)
  }

  const convertFtInchValue = (value, type = MEASURE_UNITS.FT) => {
    if (isEmpty(value) || isNaN(value)) {
      return value
    } else {
      const convertValue = {
        [MEASURE_UNITS.FT]: Number(value) / 12,
        [MEASURE_UNITS.INCH]: Number(value) * 12,
      }

      return toFractionDigits(convertValue[type])
    }
  }

  const converterValues = useMemo(() => {
    return {
      [MEASURE_UNITS.FT]: convertFtInchValue(original, MEASURE_UNITS.FT),
      [MEASURE_UNITS.INCH]: original,
    }
  }, [original])

  useLazyEffect(() => {
    onChange(values.wallLength)
  }, [values.wallLength])

  return (
    <React.Fragment>
      <MultiInputConveter values={converterValues}>
        {(converter) => {
          return (
            <Field name="wallLength">
              {({ field }) => (
                <React.Fragment>
                  <InputGroup
                    name={MEASURE_UNITS.FT}
                    value={converter.values[MEASURE_UNITS.FT]}
                    addonAfter="ft"
                    onChange={(e) => {
                      const inchValue = convertFtInchValue(e.target.value, MEASURE_UNITS.INCH)
                      converter.onChange(e)
                      converter.setFieldValue(MEASURE_UNITS.INCH, inchValue)
                      setFieldValue('wallLength', inchValue)
                    }}
                    onBlur={(e) => {
                      const formattedValue = toDecimalValue(e.target.value)
                      converter.setFieldValue(e.target.name, formattedValue)
                    }}
                  />
                  <span>=</span>
                  <InputGroup
                    {...field}
                    onChange={(e) => {
                      field.onChange(e)
                      const ftValue = convertFtInchValue(e.target.value, MEASURE_UNITS.FT)
                      converter.onChange(e)
                      converter.setFieldValue(MEASURE_UNITS.FT, ftValue)
                    }}
                    onBlur={(e) => {
                      field.onBlur(e)
                      const formattedValue = toDecimalValue(e.target.value)
                      converter.setFieldValue(e.target.name, formattedValue)
                      setFieldValue(e.target.name, formattedValue)
                    }}
                    addonAfter={MEASURE_UNITS.INCH}
                  />
                </React.Fragment>
              )}
            </Field>
          )
        }}
      </MultiInputConveter>
      {RenderIf(
        errors.wallLength,
        <span className="input-error is-visible">{errors.wallLength}</span>,
      )}
    </React.Fragment>
  )
}

WallLengthInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default memo(WallLengthInput)
